import {
  createSlider as apiCreateSlider,
  deleteSlider as apiDeleteSlider,
  getAdminSlider,
  getAdminSliders,
  getPublicSliders,
  updateSlider as apiUpdateSlider,
} from '../lib/api';
import {
  sliderToBannerSlide,
  type BannerSlideDisplay,
  type Slider,
  type SliderCreateInput,
  type SliderUpdateInput,
} from '../types/slider';

function sortSliders(sliders: Slider[]): Slider[] {
  return [...sliders].sort((a, b) => a.sort_order - b.sort_order || a.id - b.id);
}

export async function getSlides(): Promise<Slider[]> {
  return sortSliders(await getAdminSliders());
}

/** Active sliders mapped for the storefront banner carousel. */
export async function getHomeBannerSlides(): Promise<BannerSlideDisplay[]> {
  const sliders = sortSliders(await getPublicSliders());
  return sliders.map(sliderToBannerSlide);
}

export {
  getPublicSliders,
  getAdminSlider,
  apiCreateSlider as createSlider,
  apiUpdateSlider as updateSlider,
  apiDeleteSlider as deleteSlider,
};

export type { Slider, SliderCreateInput, SliderUpdateInput };
